<template>
  <div class="signContract_warpper" :class="{ signedContract: !btnShow }">
    <div class="car_rent_signature_nav">
      <navbar
        title="合同签署"
        :lefticon="lefticon"
        :lefticonheight="2.4"
        :lefticonwidth="2.4"
        :fontweight="700"
        :fontsize="'1.7rem'"
        @goback="goBack(false)"
      />
    </div>
    <div class="signContract_content">
      <div class="stepper-warpper">
        <van-stepper
          v-model="value"
          input-width="40px"
          step="0.1"
          :decimal-length="1"
          :disabled="isDisabled"
          @change="stepperOnchange"
        />
        <div class="percent">{{ percentValue }}</div>
      </div>
      <div class="contentBox">
        <div id="contidract" ref="contidract">
          <div :style="pdfStyle" ref="pdfbox">
            <pdf
              v-for="i in numPages"
              :key="i"
              :src="pdfSrc"
              :page="i"
              ref="pdfs"
              @loaded="pdfLoaded(i)"
              :style="{ width: '100%' }"
            >
            </pdf>
          </div>
        </div>
      </div>
    </div>
    <btn
      v-if="btnShow"
      class="btn_sign"
      :btntext="'签署'"
      :btnwidth="'34.3rem'"
      :height="'4.8rem'"
      :bgcolor="'linear-gradient(to right, #49A6FF, #236DFE)'"
      :borderradius="'0.6rem'"
      :btncolor="'#fff'"
      :fontsize="'1.6rem'"
      :fontweight="700"
      @btnClick="goSign"
    />
  </div>
</template>
<script>
import pdf from "vue-pdf";
import navbar from "../purchaseSupplier/components/nav-bar.vue";
import btn from "../purchaseSupplier/components/button.vue";
export default {
  components: {
    pdf,
    navbar,
    btn,
  },
  data() {
    return {
      lefticon: require("@/assets/carRent/reback@2x.png"),
      pdfSrc: "",
      pdfStyle: { "transform-origin": "left top" },
      numPages: undefined,
      contractId: "",
      btnShow: false,
      value: 1,
      isDisabled: false,
    };
  },
  created() {
    if (this.$route.query.signed == 2) {
      this.pdfSrc = sessionStorage.getItem("pdfSrc");
      this.pdfSrc = decodeURIComponent(this.pdfSrc);
      if (this.pdfSrc && this.pdfSrc.startsWith("http")) {
        this.pdfSrc = location.protocol + "//" + this.pdfSrc.split("//")[1];
      }
      if (this.pdfSrc) {
        this.pdfSrc = pdf.createLoadingTask(this.pdfSrc);
        this.pdfSrc.promise.then((pdf) => {
          this.numPages = pdf.numPages;
        });
      }
    } else {
      this.getContract();
    }
    if (!this.$route.query.from) {
      sessionStorage.setItem("pushEnter", true);
    }
  },
  computed: {
    percentValue() {
      return parseInt(parseFloat(this.value) * 100) + "%";
    },
  },
  methods: {
    stepperOnchange() {
      this.$nextTick(() => {
        this.pdfStyle.transform = `scale(${this.value})`;
        // 刷新pdf整体容器，解决IOS放大缩小后的样式混乱BUG
        this.$refs.pdfbox.style.display = "none";
        this.isDisabled = true;
        setTimeout(() => {
          // 刷新pdf整体容器，解决IOS放大缩小后的样式混乱BUG
          this.$refs.pdfbox.style.display = "block";
        }, 10);
        setTimeout(() => {
          this.isDisabled = false;
        }, 200);
      });
    },
    getContract() {
      this.$api
        .post(
          this.$route.query.signed != 1
            ? "/onorder/member/car/contract"
            : "/onorder/member/car/contract-again",
          {
            order_id: this.$route.query.order_id,
          }
        )
        .then((res) => {
          if (this.$route.query.signed != 2) {
            //0未签署 1重新签署 2已签署
            this.btnShow = true;
          }
          this.contractId = res.contract_id;
          this.pdfSrc = decodeURIComponent(res.base_file_url);
          if (this.pdfSrc && this.pdfSrc.startsWith("http")) {
            this.pdfSrc = location.protocol + "//" + this.pdfSrc.split("//")[1];
          }
          if (this.pdfSrc) {
            this.pdfSrc = pdf.createLoadingTask(this.pdfSrc);
            this.pdfSrc.promise.then((pdf) => {
              this.numPages = pdf.numPages;
            });
          }
        })
        .catch((err) => {
          this.hasList = false;
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        });
    },
    goBack() {
      if (this.$route.query.from) {
        this.$router.go(-1);
      } else {
        this.$router.replace("/carRent/carList");
      }
    },
    async pdfLoaded(i) {
      // not last page
      if (this.numPages !== i) {
        return;
      }
    },
    goSign() {
      this.$router.push({
        path: "/carRent/signature",
        query: {
          contract_id: this.contractId,
        },
      });
    },
  },
};
</script>
<style>
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
</style>
<style lang="less">
.signContract_warpper {
  box-sizing: border-box;
  background-color: #f5f6f7;
  height: 100%;
  padding: 10.5rem 0 12.5rem;

  .car_rent_signature_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    background-color: #fff;
    z-index: 3;
  }

  .signContract_content {
    height: 100%;
    padding: 0 1.6rem;
    box-sizing: border-box;
    position: relative;

    .stepper-warpper {
      position: absolute;
      z-index: 9;
      height: 28px;
      background-color: #fff;
      width: calc(100% - 3.2rem);

      .van-stepper {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
      }

      .percent {
        position: absolute;
        height: 28px;
        line-height: 28px;
        width: 40px;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
        background-color: #f2f3f5;
        font-size: 13px;
      }
    }

    .contentBox {
      height: 100%;
      box-sizing: border-box;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
      border-radius: 0.8rem;
      background: #fff;

      #contidract {
        &::-webkit-scrollbar {
          display: none;
        }
        overflow: scroll;
        position: relative;
      }
    }
  }

  .btn_sign {
    position: fixed;
    left: 1.6rem;
    bottom: 3.6rem;
  }
}

.signedContract {
  padding-bottom: 1.6rem;
}
</style>
